import { Typography } from '@mui/material';
import type { RestoreJob } from '@repo/api-gw-sdk';

import { QueryResultsField } from '@/app/(dashboard)/jobs/[tab]/queryResultsField';
import { PropertyType, type FilterProperty } from '@/types/advanceFilter';

export const queryResults: FilterProperty<RestoreJob> = {
  name: 'queryResults',
  displayName: 'Query results',
  type: PropertyType.String,
  group: 'restore-to',
  field: {
    Component: ({ entity }) => {
      return (
        entity.destinationDetails.restoreResult?.recordRestore
          ?.outputLocations && <QueryResultsField entity={entity} />
      );
    },
  },
};

export const snapshotId: FilterProperty<RestoreJob> = {
  name: 'snapshotId',
  displayName: '  ',
  type: PropertyType.String,
  group: 'restore-to',
  field: {
    Component: ({ entity }) => {
      return (
        entity.destinationDetails.restoreResult?.awsEbsSnapshot?.snapshotId && (
          <Typography>
            {entity.destinationDetails.restoreResult.awsEbsSnapshot.snapshotId}
          </Typography>
        )
      );
    },
  },
};

export const instanceId: FilterProperty<RestoreJob> = {
  name: 'instanceId',
  displayName: 'Instance',
  type: PropertyType.String,
  group: 'restore-to',
  field: {
    Component: ({ entity }) => {
      return (
        entity.destinationDetails.restoreResult?.awsEc2Instance?.instanceId && (
          <Typography>
            {entity.destinationDetails.restoreResult.awsEc2Instance.instanceId}
          </Typography>
        )
      );
    },
  },
};

export const volumeId: FilterProperty<RestoreJob> = {
  name: 'volumeId',
  displayName: 'Volume',
  type: PropertyType.String,
  group: 'restore-to',
  field: {
    Component: ({ entity }) => {
      return (
        entity.destinationDetails.restoreResult?.azureDisk?.diskId && (
          <Typography>
            {entity.destinationDetails.restoreResult.azureDisk.diskId}
          </Typography>
        )
      );
    },
  },
};

export const diskId: FilterProperty<RestoreJob> = {
  name: 'diskId',
  displayName: 'Disk',
  type: PropertyType.String,
  group: 'restore-to',
  field: {
    Component: ({ entity }) => {
      return (
        entity.destinationDetails.restoreResult?.azureDisk?.diskId && (
          <Typography>
            {entity.destinationDetails.restoreResult.azureDisk.diskId}
          </Typography>
        )
      );
    },
  },
};

export const imageId: FilterProperty<RestoreJob> = {
  name: 'imageId',
  displayName: 'Image',
  type: PropertyType.String,
  group: 'restore-to',
  field: {
    Component: ({ entity }) => {
      return (
        entity.destinationDetails.restoreResult?.awsEc2Ami?.imageId && (
          <Typography>
            {entity.destinationDetails.restoreResult.awsEc2Ami.imageId}
          </Typography>
        )
      );
    },
  },
};

export const restoredPersistentVolumes: FilterProperty<RestoreJob> = {
  name: 'restoredPersistentVolumes',
  displayName: 'Restored Persistent Volumes',
  type: PropertyType.String,
  group: 'restore-to',
  field: {
    Component: ({ entity }) => {
      return (
        entity.destinationDetails.restoreResult?.eksNamespaceRestore
          ?.volumes && (
          <Typography>
            {entity.destinationDetails.restoreResult.eksNamespaceRestore.volumes
              .map((x: { restoredVolumeId: string }) => x.restoredVolumeId)
              .filter((x: string) => !!x)
              .join(', ')}
          </Typography>
        )
      );
    },
  },
};
